import { baseApi } from 'lib/rtkQuery/baseApi';
import { QueryTags } from 'lib/rtkQuery/constants';
import { invalidatesTags } from 'lib/rtkQuery/helpers';
import qs from 'qs';
import {
  TCompanyListItem,
  TGetCompanyListParams,
  TGetWorkCompanyQueryParams,
  TWorkCompany,
} from './types';

export const companyApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [QueryTags.Company],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getCompanyList: builder.query<TCompanyListItem[], TGetCompanyListParams>({
        query: params => ({
          url: '/companies',
          method: 'GET',
          params,
        }),
        providesTags: [QueryTags.Company],
      }),

      getWorkCompanyList: builder.query<
        TWorkCompany[],
        TGetWorkCompanyQueryParams
      >({
        query: params => {
          const queryParams = qs.stringify(params, {
            arrayFormat: 'repeat',
            encode: false,
          });
          return {
            url: `/documents-accessibilities?${queryParams}`,
            method: 'GET',
          };
        },
        providesTags: [QueryTags.WorkScheduleManagement],
      }),

      putCompany: builder.mutation<void, string[]>({
        query: codes => {
          return {
            url: `/document-accessibility-v2`,
            method: 'PUT',
            data: {
              access_types: codes,
              type: 'WORK_SCHEDULE',
            },
          };
        },
        invalidatesTags: invalidatesTags([QueryTags.WorkScheduleManagement]),
      }),
    }),
  });

export const {
  useGetCompanyListQuery,
  useGetWorkCompanyListQuery,
  usePutCompanyMutation,
} = companyApi;
